import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-confirma-exclusao',
    templateUrl: './confirma-exclusao.component.html',
    styleUrls: ['./confirma-exclusao.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class ConfirmaExclusaoComponent {

  @Input() confirmaExclusao: boolean = false;
  @Output() confirmaExclusaoFechou = new EventEmitter();

  constructor() { }

  fecharAlertConfirmacao(acao: string) { this.confirmaExclusaoFechou.emit(acao); }

}
